import React from 'react';
import '../styles/global.css';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p className="footer-text">
          <strong>Restaurant QR Menu System</strong>
        </p>
        <p className="footer-text">
          Made with ❤️ for better dining experience
        </p>
        <p className="footer-text">
          &copy; {currentYear} All Rights Reserved
        </p>
      </div>
    </footer>
  );
}
